import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
} from "@mui/material";

const MatchStartModal = ({ open, handleClose, handleSubmit }) => {

  const [error, setError] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Start Match</Typography>
        </form>
        <div>
        {error && (
          <Alert
            severity="error"
            onClose={() => {
              setError("");
            }}
          >
            {error}
          </Alert>
        )}
      </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Start
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MatchStartModal;
